export interface Service {
    id?: number;
    name: string;
    is_active?: boolean;
}

export interface ServiceDataForm {
    id?: number;
    name?: string;
    description?: string;
    sector_id?: number | null;
    sector?: string;
    item_category_id?: number | null;
    item_category?: string;
    unit_id?: number | null;
    unit?: string;
    unit_symbol?: string;
    sales_name?: string;
    sales_tax_id?: number | null;
    sales_tax?: string;
    purchase_name?: string;
    purchase_tax_id?: number | null;
    purchase_tax?: string;
    is_active?: boolean;
}

export const defaultServiceDataForm: ServiceDataForm = {
    name: '',
    description: '',
    sector_id: null,
    item_category_id: null,
    unit_id: null,
    sales_name: '',
    sales_tax_id: null,
    purchase_name: '',
    purchase_tax_id: null,
};

export interface ServiceFilters {
    id?: number | null;
    name?: string | '';
    sector?: string | '';
    item_category?: string | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
}